import axios from 'axios'

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_ENGINE_URL ?? '/api',
  withCredentials: false,
})

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('ludus.token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})
